import type { ComponentType } from 'react';
import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import {
  AiBrowserIcon,
  BrowserIcon,
  Radar01Icon,
  ServerStack01Icon,
} from '@terra/ui-icons';
import { TARGET_TYPE } from '../../../utils/target-scope.utils';
import type { TargetsCatalogSliceStatus } from '../../../hooks/useTargets';

export type SurfaceLabelKey =
  | 'webApplications'
  | 'externalNetworks'
  | 'internalNetworks'
  | 'aiApplications';
export type SurfaceIconComponent = ComponentType<{
  size?: number;
}>;
export type AttackSurfaceConfig = {
  targetType: TargetTypeType;
  icon: SurfaceIconComponent;
  labelKey: SurfaceLabelKey;
  catalogSliceKey?: keyof TargetsCatalogSliceStatus;
};
export const ATTACK_SURFACES: AttackSurfaceConfig[] = [
  {
    targetType: TARGET_TYPE.WEB_APPLICATION,
    icon: BrowserIcon,
    labelKey: 'webApplications',
  },
  {
    targetType: TARGET_TYPE.EXTERNAL_NETWORK,
    icon: Radar01Icon,
    labelKey: 'externalNetworks',
    catalogSliceKey: 'externalNetworks',
  },
  {
    targetType: TARGET_TYPE.INTERNAL_NETWORK,
    icon: ServerStack01Icon,
    labelKey: 'internalNetworks',
    catalogSliceKey: 'internalNetworks',
  },
  {
    targetType: TARGET_TYPE.AI_APPLICATION,
    icon: AiBrowserIcon,
    labelKey: 'aiApplications',
    catalogSliceKey: 'aiApplications',
  },
];
export function isAttackSurfaceEnabled({
  surface,
  catalogSliceStatus,
}: {
  surface: AttackSurfaceConfig;
  catalogSliceStatus: TargetsCatalogSliceStatus;
}): boolean {
  if (!surface.catalogSliceKey) {
    return true;
  }

  return catalogSliceStatus[surface.catalogSliceKey] !== 'disabled';
}

export function findAttackSurface(
  targetType: string,
): AttackSurfaceConfig | undefined {
  return ATTACK_SURFACES.find((entry) => entry.targetType === targetType);
}

export function getAttackSurfaceIcon(targetType: string): SurfaceIconComponent {
  return findAttackSurface(targetType)?.icon ?? BrowserIcon;
}
